import { ChatAlertIcon } from './ChatAlertIcon';

/**
 * author: Austin Andrews
 * id 7E35E8CF-E958-43D7-9B28-072E3161618A
 * name chat-alert
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chat-alert.svg
 * tags
 * - Alert / Error 
 */
export const ChatWarningIcon = ChatAlertIcon;
export default ChatWarningIcon